import { useState } from 'react'
import useErrorReporter from './useErrorReporter'

export default function useStateManager(updateFn, { initialState = null } = {}) {
  const reportError = useErrorReporter()
  const [state, setState] = useState(initialState)
  const handleChangeState = async (newState, ...rest) => {
    setState(newState)
    try {
      await updateFn(newState, ...rest)
    } catch (error) {
      setState(state)
      reportError(error)
    }
  }
  return {
    state,
    handleChangeState,
  }
}
